export class ListIngestionPipelineHistoryRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListIngestionPipelineHistoryFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortPipelineHistoryBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListIngestionPipelineHistoryRequest.attributeTypeMap;
    }
    constructor() {
    }
}
